import React from 'react';
import { Upload } from 'antd';

function MultiFileUpload(props) {
  const {
    onChange, accept, children, fileList
  } = props;

  return (
    <Upload
      name="file"
      onChange={onChange}
      beforeUpload={() => false}
      accept={accept}
      showUploadList={false}
      multiple
      fileList={fileList}
    >
      {children}
    </Upload>
  );
}

export default MultiFileUpload;
